const $ = require("jquery");

const {
    decodeHtml,
    ajaxCalls: {
        licgen,
        redirect
    },
    placeholder
} = require("../utils.js");

const {
    LEAD_FIELDS
} = require("../constants.js");

const {
    localizerData
} = require("../data/localizer.json");
const {
    submits
} = require("../data/submits.json");
const {
    footerData,
    footerSocial,
    footerSections
} = require("../data/footer.json");

class TemplateLP {

    constructor() {

        this.override = false;

        this.data = {
            langs: {
                names: {
                    en: 'English',
                    de: 'Deutsch',
                    nl: 'Nederlands',
                    fr: 'Français',
                    'latam-es': ' Español (Latinoamérica)',
                    es: 'Español',
                    it: 'Italiano',
                    tr: 'Türkçe',
                    cz: 'Český',
                    pl: 'Polski',
                    ru: 'Русский',
                    sw: 'Swedish',
                    jp: 'Japanese',
                    cn: 'Chinese',
                    hu: 'Hungarian',
                    fi: 'Finnish',
                    se: 'Swedish',
                    sv: 'Swedish',
                    da: 'Dannish',
                    no: 'Norwegian',
                    sk: 'Slovenský',
                    ro: 'Romanian',
                    pt: 'Portuguese',
                    br: 'Portuguese (BR)',
                    le: 'Español (LATAM)'
                },
                currlang: ''
            }
        };

        this.url = {

            pars: {
                lang: 'en',
                ty: false,
                tab: window.starttab
            },

            data: this.data,

            init() {
                window.ret = 'en';
                const main = this;
                const langTag = document.querySelector('meta[lang]');

                // if ($('#langPage').length > 0) {
                //     const langPage = $('#langPage').data('value');
                // }

                if (langTag !== null) {
                    main.url.pars.lang = langTag.getAttribute('lang');
                }
                // else if (langPage !== null) {
                //     main.url.pars.lang = langPage;
                // }
                else {
                    $.each(main.data.langs.names, function (k, v) {

                        window.l = window.location.pathname.replace('.html').replace('https://go.veeam.com/');

                        var wh = window.location.pathname.replace(/\//g, "").split("-");

                        if (wh.indexOf(k) >= 0) {
                            main.url.pars.lang = k;
                        }
                        // } else {
                        //   for (let w of wh) {
                        //     if (w[0] === k[0] && w[1] === k[1]) {
                        //       main.url.pars.lang = k;
                        //     }
                        //   }
                        // }
                    });

                }

                this.url.parse.call(this);

            },

            update() {

                if (this.url.pars.tab) {
                    tab = '/t-' + this.url.pars.tab
                }

                var tab = '';
                var set = this.url.pars.lang + tab;

                window.location.hash = set;

            },

            parse() {

                var wh = window.location.hash.replace('#', '');

                this.url.pars.ty = window.location.href.indexOf('-ty') !== -1;

                //[EE]: maybe this check not needed
                if (window.location.href.indexOf('.html') !== -1 && !this.url.pars.ty) {
                    //window.location.href=window.location.href.replace('.html','/');
                }

                /*if (wh !== '') {

                    wh = wh.split('/');

                    $.each(this.data.langs.names, function (k, v) {
                        if (wh[0].indexOf(k) !== -1) {
                            this.url.pars.lang = wh[0].substring(0, 2);
                        }
                    });

                    this.url.pars.tab = false;

                    $.each(wh, function (k, v) {
                        if (v.indexOf('t-') !== -1) {
                            this.url.pars.tab = v.replace('t-', '');
                        }
                    });

                    //[EE]: maybe not needed
                    //if(this.getQuery('ty')==='true'){this.pars.ty = true}else{if(this.pars.name.indexOf('-ty')!==-1){this.pars.ty=true}}
                }*/
            }

        };

        this.forms = {
            init: function () {
                //$('.mktInput input[type="radio"], .mktInput input[type="checkbox"]').addClass('radiobutton');
                if ($('form').length) {
                    //BUTTONS HERE
                    if ($('form').closest('.lpeCElement').hasClass('blue-btn')) $('#mktFrmSubmit').addClass('blue');
                    if ($('form').closest('.lpeCElement').hasClass('red-btn')) $('#mktFrmSubmit').addClass('red');

                    if ($('form').closest('.lpeCElement').hasClass('popup')) {
                        this.forms.popup.call(this);
                    } else {
                        this.forms.content.call(this);
                    }

                    this.forms.subscr_cemea.call(this);
                    this.forms.referrer.call(this);
                    this.forms.lpon.call(this);
                    this.forms.numbered.call(this);
                    this.forms.nospace.call(this);


                } else {
                    $('.formBg').css('display', 'none')
                }

            },

            referrer: function () {

                $('<li class="mktField" style="display: none;"><label>Referrer:</label><span class="mktInput"><input class="mktFormHidden" name="custom-Referrer" id="custom-Referrer" type="hidden" value=""><span class="mktFormMsg"></span></span></li>').insertBefore('#mktFrmButtons');
                $('#custom-Referrer').val(encodeURI(document.referrer.replace(/&/g, '&amp;')));
                if (document.referrer === '') {
                    $('#custom-Referrer').val('NULL');
                }

            },

            lpon: function () {
                $('<li class="mktField" style="display: none;"><label>LP:</label><span class="mktInput"><input class="mktFormHidden" name="custom-LP" id="custom-LP" type="hidden" value=""><span class="mktFormMsg"></span></span></li>').insertBefore('#mktFrmButtons');
                $('#custom-LP').val(encodeURI(window.location.href.replace(/&/g, '&amp;')));
            },

            numbered: function () {
                var selector = '#Number_of_Sockets__c';
                $(selector).bind('keyup', function () {
                    $(this).val($(this).val().replace(/\D/g, ''));
                });
            },

            nospace: function () {
                var selector = '#Email';
                $(selector).bind('change', function () {
                    $(this).val($(this).val().replace(/ /g, ''));
                });
            },

            subscr_cemea: function () {
                var phrase = 'Ich stimme den Allgemeinen <a href="https://www.veeam.com/de/privacy_policy.html" target="_blank">Nutzungsbedingungen</a> und der Datenschutzerklärung (Privacy Policy) ausdrücklich zu';
                if (window.location.href.indexOf("veeam-cebit-2014-de") !== -1) {
                    phrase = 'Veeam Newsletter<br>abonnieren';
                }
                var html = '<li class="mktField"><label>' + phrase + '</label><span class="mktInput" style="width: 30px !important; text-align: left;"><input class="mktFormCheckbox" name="temp-EMEA-CEMEA-Germany-confirmed-subscription" id="temp-EMEA-CEMEA-Germany-confirmed-subscription" type="checkbox" value="1" tabindex="3" style="width: 20px !important;"><span class="mktFormMsg"></span></span></li>';
                if (this.url.pars.lang === 'de' && (this.subscription.get().cemea_subscr === '' || this.subscription.get().cemea_subscr !== '1')) {
                    $(html).insertBefore('#mktFrmButtons');
                }
            },

            validate: {
                url: 'https://www.veeam.com/jsonp/?callback=validate',

                field: function (el, cb) {

                    if (typeof this.forms.validate.mask[$(el).attr('name')] !== 'undefined') {
                        m = this.forms.validate.mask[$(el).attr('name')];
                    }

                    m = this.forms.validate.mask.def;

                    $.ajax({
                        url: this.forms.validate.url,
                        data: {
                            val: $(el).val(),
                            fld_name: m.fld_name,
                            mask: m.mask,
                            lng: this.url.pars.lang
                        },
                        jsonpCallback: "validate",
                        dataType: "jsonp",
                        success: function (data) {
                            this.forms.validate.throwError(el, data);
                            data = $.parseJSON(data.html);
                            cb(data[0]["Invalid"] !== "0");
                        }
                    });
                },

                mask: {
                    Email: {
                        mask: 'R,email,notpublic',
                        fld_name: 'email'
                    },
                    FirstName: {
                        mask: 'R,Symbol,Max',
                        fld_name: 'first_name'
                    },
                    LastName: {
                        mask: 'R,Symbol,Max',
                        fld_name: 'last_name'
                    },
                    def: {
                        mask: 'R',
                        fld_name: 'city'
                    }
                },

                overrideSubmit: function () {
                    $('form').removeAttr('onsubmit');
                    $('#mktFrmSubmit').removeAttr('onclick');
                    $('form').submit(function () {

                        if (!$(':input.error').length) {

                            this.forms.validate.field($('#Email'), function (bool) {

                                if (!bool) {
                                    formSubmit(document.getElementById($('form').attr('id')));
                                }
                            });

                        }

                        return;
                    });
                },

                throwError: function (el, data) {
                    data = $.parseJSON(data.html);
                    if (data[0]["Invalid"] !== "0") {
                        $(el).addClass('error').parent().find('.error-msg').fadeIn(300).html(data[0]["Mesg"]);
                    } else {
                        $(el).removeClass('error').parent().find('.error-msg').html('');
                    }
                },

                bool: false,

                init: function () {
                    if (!this.forms.validate.bool) {
                        this.forms.validate.overrideSubmit();

                        $('.lpeRegForm input').parent().append('<div class="error-msg"></div>');
                        $('.lpeRegForm input').change(function () {
                            this.forms.validate.field($(this), function () {});
                        });
                        this.forms.validate.field($('#Email'), function () {});
                        this.forms.validate.bool = true;
                    }
                }

            },

            content: function () {
                var classname = $('form').closest('.lpeCElement').attr('class');
                $('form').closest('.formSpan').contents().add('<div class="clr"></div>').appendTo('.form-content');
                $('.form-content').prepend($('.formTitle').css('position', 'static'));
                if (!this.url.pars.ty) {
                    $('.formBg').css('display', 'block').addClass(classname);
                }
            },

            popup: function () {
                $('form').closest('.formSpan').contents().add('<div class="clr"></div>').appendTo('.form-content');
                $('.form-content').prepend($('.formTitle').css('position', 'static'));
                $('.formBg').css('display', 'none');
            },

            trial: {
                init: function () {
                    this.forms.trial.overrideSubmit();

                },
                off: function () {
                    $('#mktFrmSubmit').unbind('click');
                    $('form').submit(function () {
                        formSubmit(document.getElementById($('form').attr('id')));
                    });
                },
                overrideSubmit: function () {

                    $('#mktFrmSubmit').attr('onclick', 'return false');
                    $('form').submit(function () {
                        return false;
                    });
                    $('#mktFrmSubmit').click(function () {
                        $('#mktFrmSubmit').attr('disabled', 'disabled').addClass('disabled');
                        if ($(':input.error').length === 0) {
                            this.forms.validate.field($('#Email'), function (bool) {
                                if (!bool) {
                                    this.forms.trial.send(function () {
                                        formSubmit(document.getElementById($('form').attr('id')));
                                    });
                                }
                            });

                        }
                        return false;
                    });
                },
                send: function (c, d) {
                    if (typeof d === 'undefined') {
                        d = {
                            //cc: window.location.pathname.replace('/','').replace('/',''),
                            //prd: 'vmware-esx-backup-hyper-v',
                            first_name: $('#FirstName').val(),
                            last_name: $('#LastName').val(),
                            email: $('#Email').val(),
                            //phone: $('#Phone').val(),
                            company: $('#Company').val()
                            //country:$('#Country').val(),
                            //city:$('#City').val();
                        }
                    }

                    if (!$.support.cors) {

                        $('body').append('<iframe id="trial" src="https://mkto.veeam.com/trial/get/?' + $.param(d) + '" style="display:none;"></iframe>');
                        $('#trial').load(function () {
                            c();
                            //maybe not needed
                            //_gaq.push(['_trackEvent', 'TY - Request Trial', 'one-click',  window.location.href]);
                        });
                    } else {

                        $.ajax({
                            url: 'https://mkto.veeam.com/trial/get/',
                            type: 'get',
                            data: d,
                            jsonpCallback: "licgen",
                            dataType: "jsonp",
                            success: function (data) {
                                c(data);
                                //maybe not needed
                                //_gaq.push(['_trackEvent', 'TY - Request Trial', 'one-click',  window.location.href]);
                            }
                        });

                    }

                }

            }

        };

        this.localizer = {
            override: false,
            nolang: true,
            forms: {
                data: localizerData,

                init: function () {

                    if (!this.localizer.forms.data[this.url.pars.lang]) {
                        return;
                    }

                    const main = this;

                    $.each(this.localizer.forms.data[this.url.pars.lang], function (key, value) {
                        window.sel = 'input[name=' + key + '], select[name^=' + key + '], textarea[name=' + key + ']';
                        if (value.indexOf('?') === -1) value += ':';
                        $(sel).closest('.mktoField').find('label').text(value);
                        $(sel).find('option:eq(0)').text(value);
                    });

                    setTimeout(function () {
                        $.each(main.localizer.forms.data[main.url.pars.lang], function (key, value) {
                            window.sel = 'input[name=' + key + '], select[name^=' + key + '], textarea[name=' + key + ']';
                            if (value.indexOf('?') === -1) value += ':';
                            $(sel).siblings('label').text(value);
                            $(sel).find('option:eq(0)').text(value);
                        });

                    }, 500);

                    $('#mktFrmButtons input[type=submit]').val(main.localizer.submits[main.url.pars.lang]);

                },

                localizeForms: function () {
                    const main = this;
                    const ids = ['Email', 'FirstName', 'firstNameMKTO', 'LastName',
          'lastNameMKTO', 'Company', 'companyMKTO', 'Title', 'Phone'];

                    const formsData = main.localizer.forms.data;

                    const pageForms = $("form");

                    if (pageForms.length) {
                        pageForms.each((index, form) => {

                            if ($(form).attr("class").indexOf("mkto") >= 0) {

                                ids.forEach((id) => placeholder(`#${id}`,
                                    formsData[main.url.pars.lang][id]));

                            }

                        });
                    }
                }
            },

            submits: submits,

            footer: {
                data: footerData,
                social: footerSocial,

                init: function () {
                    const main = this;
                    $('#footer .footer-communities a:eq(6)').hide();

                    if (main.url.pars.lang === "de") {
                        $('#footer .footer-communities a:eq(5)').hide();
                        $('#footer .footer-communities a:eq(6)').show();
                    } else {
                        $('#footer .footer-communities a:eq(5)').show();
                        $('#footer .footer-communities a:eq(6)').hide();
                    }

                    $('#footer .footer-resourses a').each(function (k, v) {

                        $(this)
                            .attr('href', main.localizer.footer.data[main.url.pars.lang][k]["href"] + '?ad=lp-emea')
                            .html(main.localizer.footer.data[main.url.pars.lang][k]["name"]);
                    });
                    setTimeout(function () {

                        $('#footer .footer-resourses p').html(footerSections[main.url.pars.lang].resources);
                        $('#footer .footer-communities p').html(footerSections[main.url.pars.lang].communities);

                        $('#footer .footer-copyright a').html(footerSections[main.url.pars.lang].privacy.text)
                            .attr('href', footerSections[main.url.pars.lang].privacy.url);

                        $('#footer .footer-communities img[alt="facebook"]').closest("a")
                            .attr("href", footerSocial[main.url.pars.lang].facebook);

                        $('#footer .footer-communities img[alt="twitter"]').closest("a")
                            .attr("href", footerSocial[main.url.pars.lang].twitter);

                    }, 2000);
                }
            },

            awards: function () {
                window.lang = this.url.pars.lang;
                if (this.url.pars.lang === 'le') {
                    window.lang = 'es'
                };
                if (this.localizer.nolang) {
                    lang = ''
                } else {
                    window.lang += '/'
                }


                if (this.url.pars.lang === 'latam-es') { //If LATAM-ES
                    $('#logo2').attr('href', 'https://veeam.com/es-lat/data-center-availability-suite.html');
                    $('#logo').attr('href', 'https://veeam.com/es-lat');
                    $('#add-logo').attr('href', 'https://veeam.com/es-lat/data-center-availability-suite.html');
                }

                $('#logo2').attr('href', 'https://veeam.com/' + lang + 'data-center-availability-suite.html');
                $('#logo').attr('href', 'https://veeam.com/' + lang);
                $('#add-logo').attr('href', 'https://veeam.com/' + lang + 'data-center-availability-suite.html');

            },

            init: function () {
                this.localizer.nolang = (this.url.pars.lang === 'en' || this.url.pars.lang === 'hu' || this.url.pars.lang === 'fi' || this.url.pars.lang === 'se' || this.url.pars.lang === 'da' || this.url.pars.lang === 'no' || this.url.pars.lang === 'sk' || this.url.pars.lang === 'ro' || this.url.pars.lang === 'sw' || this.url.pars.lang === 'sv');

                this.localizer.forms.init.call(this);
                this.localizer.awards.call(this);
                this.localizer.footer.init.call(this);

            }
        };

        this.subscription = {
            init: function () {
                if (typeof LEAD_FIELDS !== 'undefined') {
                    if (this.subscription.get().unsubscribed === "1" && this.url.pars.ty) {
                        $('#banner-container').css('bottom', '58px');
                        $('#status-output').html('<p class="btop"><img src="https://mkto.veeam.com/files/assets/Subscribe.png">Your current email subscription status is <b>Unsubscribed</b>. <a target="_blank" href="https://go.veeam.com/subscriptions.html?DynamicEmail=' + this.subscription.get()[0] + '&ad=resubscribe">Subscribe back here</a>');
                    }

                }

            },

            get: function () {
                window.ret = {};
                if (typeof LEAD_FIELDS !== 'undefined') {
                    $.each(LEAD_FIELDS, function (k, v) {
                        window.ret[k] = decodeHtml(v);
                    });
                }

                return window.ret;

            }

        };

        this.devMode = {
            init: function () {
                $('.content-output').css('display', 'block');
                $('#status-output').css({
                    backgroundColor: '#EEE',
                    height: '61px',
                    color: '#AAA'
                }).html('UNSUBSCRIBE ON TY');
            }

        };

    }

    onInit() {

        this.url.init.call(this);
        this.localizer.init.call(this);
        this.forms.init.call(this);
        this.subscription.init.call(this);
        this.analyticsFix.call(this);

    }

    update() {
        this.url.parse.call(this);
    }

    init(f) {

        if (typeof window.overrideTemplateGlobal === 'undefined') {
            window.overrideTemplateGlobal = false;
        }

        if (!this.override && !overrideTemplateGlobal) {

            $('.lpeCElement').each(function () {
                $(this).attr('class', $(this).attr('class').replace(/_/g, ' '));
            });

            $('.content-output').fadeIn('300');

            this.update();


            //this.forms.validate.init();
        }

    }

    analyticsFix() {

        if (window.location.hash !== '') {

            dataLayer.push({
                event: 'pageview',
                pageview: window.location.href
            });

        }

        if (window.location.search !== '' || window.location.hash !== '') {

            $('input[name=returnLPId]').val('-1');
            $('input[name=returnURL]').val($('input[name=returnURL]').val() + window.location.search + window.location.hash);
            $('input[name=retURL]').val($('input[name=retURL]').val() + window.location.search + window.location.hash);

        }

    };

}

module.exports = {
    TemplateLP
};



// WEBPACK FOOTER //
// ./src/modules/templateLP.js